import React, { Component } from 'react';
import { Col, Row, Alert } from 'react-bootstrap/lib';
import { DateInput, LoadingScreen, VehSingleDropDown } from '../../generic/input';
import { MENUPATH } from "../../lib/enums";
import { TODAY_START_TS, TODAY_END_TS, TODAY_START_TS_IN_SEC } from '../../lib/enums';
import { ShowErrorMsg } from '../../generic/genericFunctions';
import { isVehValid } from '../../lib/common';
import { GetStatsFromDB, GetDailyStats } from '../../db/stats';
import { getLatestEventsWTS } from '../../db/timelineEvents';
import bgImage from "../../images/waitRide.png";
import { browserHistory } from 'react-router';
import DailyStatsTiles from './dailyStatsTiles';
const DAILY_STATS_COUNT = 5;

export default class DailyStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dailyStats: [],
      errMsg: "",
      isLoading: false,
      vehFltrTitle: "Vehicle filter",
      disPrevBtn: false,
      infoMsg: "",
      loadMore: false
    }
    this.filters = {};
    this.vehMap = {};

    global.EE.addEventListener(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, this.onTlEvents);
  }

  componentDidMount() {
    if (global.wsOnline && global.bikeDetails) this.onVehicles(global.bikeDetails);
    global.EE.emitEvent(global.EE.EVENT_TYPES.MENU_CHANGE, MENUPATH.DAILY_RIDES);
  }

  componentWillUnmount() {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, this.onTlEvents);
  }

  onVehicles = (vehicles) => {
    this.vehicles = vehicles;

    if (vehicles && vehicles.length) {
      vehicles.forEach(veh => {
        this.vehMap[veh.idx] = veh.mo + " " + (veh.treg || veh.reg);
      });
    }
    var loc = this.props.location;
    if ((loc.query && loc.query.veh && !Array.isArray(loc.query.veh)) || this.vehicles.length === 1) {
      if(this.vehicles.length === 1) this.selVid = this.vehicles[0].idx;
      else this.selVid = +loc.query.veh;
      if (this.vehicles && this.selVid) this.validVeh = isVehValid(this.vehicles, [this.selVid]);
      if (this.validVeh) {
        var newUrl = loc.pathname + "?veh=" + this.selVid;
        this.props.router.replace(newUrl);
        var selVeh = this.vehicles.find(v => v.idx === this.selVid);
        this.setState({
          vehFltrTitle: ((selVeh.vmk || "") + "  " + (selVeh.mo || "") + "  " + (selVeh.reg || selVeh.treg)),
          isLoading: true
        }, () => {
          this._getLatestNotif();
        });
      } else {
        this.setState({
          errMsg: "Please select valid vehicle to see daily statistics"
        });
      }
    } else {
      this.setState({ errMsg: "Please select the vehicle to get daily statistics" })
    }
  }

  onVehSelect = (veh) => {
    let newTitle = (veh.vmk || "") + "  " + (veh.mo || "") + "  " + (veh.reg || veh.treg);
    this.selVid = veh.idx;
    var newUrl = this.props.location.pathname + "?veh=" + veh.idx;
    this.props.router.replace(newUrl);
    this.setState({
      vehFltrTitle: newTitle,
      infoMsg: "",
      loadMore: false,
      dailyStats: [],
      fromTs: null,
      toTs: null,
      isLoading: true
    });
    this._getLatestNotif();
  }

  _getLatestNotif() {
    /**
     *  Get latest events for selected vehicle
     */
    getLatestEventsWTS(this.selVid, (err, wts) => {
      if (err) {
        console.error("IndexedDB error " + err);
      } else {
        var req = { a: "getTimelineEvents", d: { veh: [{ vid: this.selVid, wts: wts || TODAY_START_TS_IN_SEC }] } }; // wts not present then request today's tlevents
        this.latestEvents = true;
        global.gWebSocket.SendRequest({ data: req });
      }
    });
  }

  onTlEvents = () => {
    if (this.latestEvents) {
      this.latestEvents = false;
      this.getTodaysStats();
    }
  }

  getTodaysStats = () => {
    let params = { vid: this.selVid, from: TODAY_START_TS, to: TODAY_END_TS };
    GetStatsFromDB(params, (err, todayStats) => {
      if (err) {
        this.setState({
          errMsg: "Server unavailable please try again later",
          isLoading: false
        });
      }
      else {
        if (!todayStats || !todayStats.length) this._getPreviousDaysStats({ count: DAILY_STATS_COUNT });
        else this.showStats(todayStats);
      }
    });
  }

  _getPreviousDaysStats = (filter) => {
    let params = { vid: this.selVid };
    if (filter && filter.lastTs) params.to = filter.lastTs;
    if (filter.count) params.limit = filter.count;

    GetDailyStats(params, (err, dStats) => {
      if (err) {
        this.setState({
          errMsg: "Server unavailable please try again later",
          isLoading: false
        });
      } else {
        if (this.state.loadMore) {
          if (dStats.length) {
            dStats.push.apply(dStats, this.loadedStats);
            this.showStats(dStats);
          }
          else {
            this.setState({
              infoMsg: "No more previous daily stats are availble for this vehicle"
            });
          }
        } else this.showStats(dStats);
      }
    });
  }

  showStats = (statsArr) => {
    if (statsArr && statsArr.length) {
      statsArr = statsArr.sort((a, b) => b.ts - a.ts);
      this.loadedStats = JSON.parse(JSON.stringify(statsArr));
      this.setState({
        minDt: null,
        maxDt: null,
        dailyStats: [],
        isLoading: false
      }, () => {
        this.setState({
          dailyStats: statsArr,
          minDt: (this.loadedStats[this.loadedStats.length - 1].ts),
          maxDt: this.loadedStats[0].ts,
        });
      })
    } else {
      this.setState({
        errMsg: "Daily Stats are not available for this vehicle",
        dailyStats: [],
        isLoading: false
      });
    }
  }

  applyDateFilter = () => {
    let stats = JSON.parse(JSON.stringify(this.loadedStats));
    if (this.state.fromTs && this.state.toTs) {
      stats = stats.filter((ds) => {
        return (ds.ts >= this.state.fromTs && ds.ts <= this.state.toTs);
      });
    }
    let errMsg;
    if (!stats.length) {
      errMsg = "Daily statistics are not present for selected date range"
    }
    this.setState({
      dailyStats: [],
    }, () => {
      this.setState({
        dailyStats: stats,
        isLoading: false,
        errMsg
      })
    });
  }

  dateChange = (e) => {
    if (e.length > 1) {
      this.setState({
        fromTs: e[0].getTime(),
        toTs: e[1].setHours(0, 0, 0, 0),
        isLoading: true
      }, () => {
        this.applyDateFilter();
      });
    }
  }

  onTileClick = (selStats) => {
    var newUrl = "/webapptl/dailyStats/detailedStats";
    newUrl += "?veh=" + selStats.vid + "&ts=" + selStats.ts;
    browserHistory.push(newUrl);
  }

  loadPrev = () => {
    if (this.loadedStats.length) {
      let lastTs = (this.loadedStats[this.loadedStats.length - 1].ts - 1);
      this.setState({
        loadMore: true
      });
      this._getPreviousDaysStats({ lastTs, count: DAILY_STATS_COUNT });
    }
  }

  render() {
    return (
      <Col>
        {this.state.isLoading ? <LoadingScreen /> : null}
        <Row style={{ marginBottom: "10px" }}>
          <Col lg={4} lgOffset={8} md={6} mdOffset={6} sm={6} smOffset={6} xs={12}>
            {
              this.vehicles && this.vehicles.length > 1 ?
                <VehSingleDropDown
                  vehicles={this.vehicles}
                  onClick={(e) => this.onVehSelect(e)}
                  title={this.state.vehFltrTitle} />
                : null
            }
          </Col>
        </Row>
        <Col lg={12} md={12} sm={12} xs={12} className={"height-75vh"} style={{ border: "1px solid #ccc", paddingTop: "15px", paddingBottom: "15px" }}>
          {
            this.loadedStats && this.loadedStats.length ?
              <Col>
                <Row>
                  {
                    this.state.minDt && this.state.maxDt ?
                      <Col lgOffset={8} lg={4} md={6} sm={6} xs={12} style={{ marginBottom: "3%" }}>
                        <DateInput height="40px" mode={true} placeholder="Select Date Range" defaultdate={[this.state.fromTs, this.state.toTs]} mindate={this.state.minDt} maxdate={this.state.maxDt} onChange={(e) => this.dateChange(e)}></DateInput>
                      </Col>
                      : null
                  }
                </Row>
                {
                  this.state.dailyStats.length ?
                    <Row style={{ height: "60vh" }} >
                      <DailyStatsTiles dailyStats={this.state.dailyStats} vehMap={this.vehMap} onTileClick={(selStats) => this.onTileClick(selStats)} />
                    </Row>
                    :
                    this.state.errMsg ? <Alert className='warning'>{this.state.errMsg}</Alert> : null
                }
              </Col>
              :
              this.state.errMsg ? ShowErrorMsg(this.state.errMsg, bgImage) : null
          }
        </Col>
        {
          this.selVid && this.state.dailyStats.length ?
            <Col lg={12} md={12} sm={12} xs={12} style={{ paddingTop: "1%", paddingLeft: "0px" }}>
              {
                this.state.infoMsg ?
                  <Alert bsStyle="info"> {this.state.infoMsg}</Alert>
                  :
                  <Col lg={3} md={4} sm={4} xs={9} style={{ paddingTop: "2%", paddingLeft: "0px" }}>
                    <button className="form-control btn-info col-lg-3 col-md-4 col-sm-4 col-xs-6" style={{}} onClick={() => this.loadPrev()} disabled={this.state.disPrevBtn}>&laquo; Load Previous</button>
                  </Col>
              }
            </Col>
            : null
        }

      </Col>
    )
  }
}